import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, description, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal>
      <span className="flex items-center gap-3">
        <span className="h-px w-10 bg-gradient-to-r from-[#00E5FF] to-[#8A2BE2]" />
        <span className="text-[11px] font-semibold tracking-[0.35em] text-white/50">
          {eyebrow}
        </span>
      </span>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-5 font-display text-3xl font-extrabold leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.2}>
        <p className="mt-5 text-base font-light text-white/65 md:text-lg">
          {description}
        </p>
      </Reveal>
    )}
  </div>
);

export default Reveal;
